"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPathDepth = exports.getAllResponses = exports.parseLinkHeader = exports.responseParser = exports.parseResponse = exports.filterByPropExtension = void 0;

var _map2 = _interopRequireDefault(require("lodash/fp/map"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _fromPairs2 = _interopRequireDefault(require("lodash/fromPairs"));

var _flow2 = _interopRequireDefault(require("lodash/flow"));

var _immutable = require("immutable");

var _path = require("./path");

var _unsentRequest = _interopRequireDefault(require("./unsentRequest"));

var _APIError = _interopRequireDefault(require("./APIError"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const filterByPropExtension = (extension, propName) => arr => arr.filter(el => (0, _path.fileExtension)((0, _get2.default)(el, propName)) === extension);

exports.filterByPropExtension = filterByPropExtension;

const catchFormatErrors = (format, formatter) => res => {
  try {
    return formatter(res);
  } catch (err) {
    throw new Error("Response cannot be parsed into the expected format (".concat(format, "): ").concat(err.message));
  }
};

const responseFormatters = (0, _immutable.fromJS)({
  json: async res => {
    const contentType = res.headers.get('Content-Type') || '';

    if (!contentType.startsWith('application/json') && !contentType.startsWith('text/json')) {
      throw new Error("".concat(contentType, " is not a valid JSON Content-Type"));
    }

    return res.json();
  },
  text: async res => res.text(),
  blob: async res => res.blob()
}).mapEntries((_ref) => {
  let [format, formatter] = _ref;
  return [format, catchFormatErrors(format, formatter)];
});

const parseResponse = async (res, _ref2) => {
  let {
    expectingOk = true,
    format = 'text',
    apiName = ''
  } = _ref2;
  let body;

  try {
    const formatter = responseFormatters.get(format, false);

    if (!formatter) {
      throw new Error("".concat(format, " is not a supported response format."));
    }

    body = await formatter(res);
  } catch (err) {
    throw new _APIError.default(err.message, res.status, apiName);
  }

  if (expectingOk && !res.ok) {
    var _body$error;

    const isJSON = format === 'json';
    const message = isJSON ? body.message || body.msg || ((_body$error = body.error) === null || _body$error === void 0 ? void 0 : _body$error.message) : body;
    throw new _APIError.default(isJSON && message ? message : body, res.status, apiName);
  }

  return body;
};

exports.parseResponse = parseResponse;

const responseParser = options => res => parseResponse(res, options);

exports.responseParser = responseParser;
const parseLinkHeader = (0, _flow2.default)([linksString => linksString.split(','), (0, _map2.default)(str => str.trim().split(';')), (0, _map2.default)((_ref3) => {
  let [linkStr, keyStr] = _ref3;
  return [keyStr.match(/rel="(.*?)"/)[1], linkStr.trim().match(/<(.*?)>/)[1].replace(/\+/g, '%20')];
}), _fromPairs2.default]);
exports.parseLinkHeader = parseLinkHeader;

const getAllResponses = async function getAllResponses(url) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let linkHeaderRelName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'next';
  const maxResponses = 30;
  let responseCount = 1;

  let req = _unsentRequest.default.fromFetchArguments(url, options);

  const pageResponses = [];

  while (req && responseCount < maxResponses) {
    const pageResponse = await _unsentRequest.default.performRequest(req);
    const linkHeader = pageResponse.headers.get('Link');
    const nextURL = linkHeader && parseLinkHeader(linkHeader)[linkHeaderRelName];
    const {
      headers = {}
    } = options;
    req = nextURL && _unsentRequest.default.fromFetchArguments(nextURL, {
      headers
    });
    pageResponses.push(pageResponse);
    responseCount++;
  }

  return pageResponses;
};

exports.getAllResponses = getAllResponses;

const getPathDepth = path => {
  const depth = path.split('/').length;
  return depth;
};

exports.getPathDepth = getPathDepth;